module.exports = "/images/arrow-in.png?0e684e9fabce28420b45af3225de4476";